import z from 'zod'
import constants from '../../constants'
import { LeaveRequestSource } from '../enums/LeaveRequestSource.enum'
import { AccountTeam } from '../enums/AccountTeam.enum'
import { LeaveTime } from '../enums/LeaveTime.enum'
import { LeaveType } from '../enums/LeaveType.enum'
import ZodHelper from '../../helpers/zod.helper'
import { ApprovalStatus } from '../enums/ApprovalStatus.enum'

const MAX_FILE_SIZE = constants.limits.maxLeaveRequestFileUploadSize

const leaveRequestCreateSchema = z
  .object({
    source: ZodHelper.zEnumFromTsEnum(LeaveRequestSource),
    approvalStatus: ZodHelper.zEnumFromTsEnum(ApprovalStatus),
    name: z.string().min(2),
    email: z.email(),
    accountTeam: ZodHelper.zEnumFromTsEnum(AccountTeam),
    position: z.string().min(2),
    startDate: z.date(),
    endDate: z.date(),
    leaveTime: ZodHelper.zEnumFromTsEnum(LeaveTime),
    leaveType: ZodHelper.zEnumFromTsEnum(LeaveType),
    otherLeaveType: z.string().nullish(),
    supportingDocument: z
      .instanceof(File)
      .refine(file => file.size <= MAX_FILE_SIZE, {
        message: `Max image size is ${Intl.NumberFormat().format(MAX_FILE_SIZE / (1024 * 1024 * 1024))}GB.`,
      })
      .nullish(),
    reason: z.string().nullish(),
  })
  .refine(
    data => {
      if (data.leaveType === LeaveType.OTHER && (!data.otherLeaveType || data.otherLeaveType.length < 2)) return false
      return true
    },
    {
      message: 'Please enter other leave type...',
      path: ['otherLeaveType'],
    },
  )

export type LeaveRequestCreateSchema = z.infer<typeof leaveRequestCreateSchema>

export default leaveRequestCreateSchema
